export default "__VITE_ASSET__C6k6kyZT__"